import { PaymentMethodProvider } from "./paymentMethodState";
import SavePaymentMethod from "./SavePaymentMethod";
import DeletePaymentMethod from "./DeletePaymentMethod";

export function AddPaymentMethodWrapper({
  children,
  setInputErrors,
  ...props
}) {
  return (
    <PaymentMethodProvider {...props}>
      {children}
      <SavePaymentMethod setInputErrors={setInputErrors} />
      <DeletePaymentMethod />
    </PaymentMethodProvider>
  );
}
